import {
  SET_ASSIGNED_QUOTAS_LIST_DATA,
  OPEN_ASSIGNED_QUOTAS_FORM_MODAL,
  CLOSE_ASSIGNED_QUOTAS_FORM_MODAL
} from '../constants/action_constants';

const initialState = {
  configs: [],
  meta: {},
  formModalIsOpen: false
};

export function assignedQuotas(state = initialState, action) {
  switch (action.type) {
    case SET_ASSIGNED_QUOTAS_LIST_DATA:
      return {
        ...state,
        configs: action.data,
        meta: {
          totalCount: action.meta.totalCount,
          currentPage: action.meta.currentPage
        }
      };
    case OPEN_ASSIGNED_QUOTAS_FORM_MODAL:
      return {
        ...state,
        formModalIsOpen: true
      };
    case CLOSE_ASSIGNED_QUOTAS_FORM_MODAL:
      return {
        ...state,
        formModalIsOpen: false
      };
    default: {
      return state;
    }
  }
};